import { Configuration, LogLevel, RedirectRequest } from '@azure/msal-browser';

import { configuration } from 'util/configurations';

export const msalConfig: Configuration = {
  auth: {
    clientId: configuration.azureClientId,
    authority: configuration.azureAuthority,
    redirectUri: `${window.location.origin}${configuration.authRedirectUri}`,
    postLogoutRedirectUri: `${window.location.origin}/login`
  },
  cache: {
    // Recommended for the redirect flow.
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false
  },
  system: {
    allowNativeBroker: false,
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        if (process.env.NODE_ENV === 'development') {
          // eslint-disable-next-line no-console
          console.debug(`[MSAL ${level}] ${message}`);
        }
      },
      logLevel:
        process.env.NODE_ENV === 'development'
          ? LogLevel.Verbose
          : LogLevel.Error
    }
  }
};

/**
 * Sign-in request. Requests the OIDC/Graph base scopes plus the punchout-customer-bff
 * API scope (when configured) so the returned access token carries the BFF audience.
 */
const baseScopes = configuration.scopes;
const apiScope = configuration.apiScope?.trim();
export const loginRequest: RedirectRequest = {
  scopes:
    apiScope && !baseScopes.includes(apiScope)
      ? [...baseScopes, apiScope]
      : baseScopes
};
